'use client';

import React from 'react';

import { submitLeadChurchForm } from '@sola/skippy-sdk/requests.ts';

import { LeadForm } from '../../../organisms/forms/lead-form/lead-form.tsx';

export const SmallChurchLeadForm: React.FC = () => {
  // TODO: Probably need direction on the success state - currently a generic thank you.
  const captureReferringUrl = true;
  return (
    <section className="component component--no-header">
      <div className="container">
        <LeadForm
          onSubmit={submitLeadChurchForm(
            'contactme',
            'SmallChurchContactForm',
            captureReferringUrl,
          )}
          config={{
            phone: { hide: false, required: false },
            role: { hide: false, required: true },
            hasChurch: true,
            website: { hide: true, required: false },
            consent: false,
          }}
        />
      </div>
    </section>
  );
};
